import axios from 'axios';
import { createApiUrl, getToken } from '../../util';
import api from 'api/axiosInstance';

async function updateExceedOffsetPermission(uuid: string, key: string) {
	const myToken = getToken('Authorization');
	const config = {
		headers: {
			'Authorization': `Bearer ${myToken}`
		}
	};

	const requestBody = {
		key
	};

	const { data } = await api.patch(createApiUrl(`/designs/change-exceed-offset-permission/${uuid}`), requestBody, config);
	return data;
}

export {
	updateExceedOffsetPermission,
};
